export function contactInit() {

    // Dropdown
    $('.custom-select-wrapper').on('click', function() {
        $('.custom-select-wrapper .custom-select').toggleClass('open');
    });

    $('.custom-option').on('click', function() {
        if (!$(this).hasClass('selected')) {
            $('.custom-select__trigger.placeholder').removeClass('placeholder');
            $('.custom-option').removeClass('selected');
            $(this).addClass('selected');
            $('.custom-select__trigger span').text($(this).text());
        }
    });


    // Submit
    $('.page-contact .btn-submit').on('click', function() {

        let btnSubmit = $(this);

        if (formValidated()) {

            // Disable submit btn
            btnSubmit.text('Submitting...');
            btnSubmit.addClass('disabled');

            // Category check
            let cat = $('#input-category .custom-select__trigger span').text();
            if (cat == "WHAT IS YOUR INQUIRY REGARDING?") {
                cat = "No category selected";
            }


            $.ajax({
                url: '/api/contact/email',
                type: 'POST',
                beforeSend: function(xhr) { xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content')) },
                data: {
                    first_name: $('#input-fname').val(),
                    last_name: $('#input-lname').val(),
                    email: $('#input-email').val(),
                    category: cat,
                    message: $('#input-message').val()
                },
                success: function(response) {
                    console.log(response);

                    $('#contact-form').fadeOut(function() {
                        $('#submitted-message').fadeIn();

                        btnSubmit.text('Submitted');
                    });
                },
                error: function(XMLHttpRequest, textStatus, errorThrown) {
                    alert("Status: " + textStatus);
                    alert("Error: " + errorThrown);
                }
            });
        }
    });

    function formValidated() {
        if ($('#input-fname').val().length &&
            $('#input-lname').val().length &&
            $('#input-email').val().length &&
            $('#input-message').val().length) {
            $('#msg-invalid').hide();
            return true;
        } else {
            $('#msg-invalid').show();
            return false;
        }
    }
}